<template>
    <div class="flex justify-between">
        <div>
            <div @click="SET_SHOW_SIDE_NAV(!getshowSideNav)" class="flex items-center justify-between flex-shrink-0" >
                <span class="px-3 mt-2 py-1 text-xl font-semibold leading-8 tracking-wider uppercase whitespace-nowrap">
                    <img alt="Logo" src="/img/logo.png" class="h-10 object-cover">
                </span>
            </div>
            {{ getPathURL }}
            <div class="flex-1 overflow-hidden hover:overflow-y-auto border-t border-gray-100">
                <div class="px-2">
                <ul class="space-y-1 border-t border-gray-100 pt-4 text-sm">
                    <li v-for="item in getItensNavBar" :key="item.id" :class="'group/principal-'+item.id" >
                        <details class="group [&_summary::-webkit-details-marker]:hidden">
                            <summary :class="{'bg-gray-200 cursor-default': activeNavItem(item)}" class="flex cursor-pointer items-center justify-between rounded-lg pl-3 py-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700">
                                <router-link :to="item.url" class="flex items-center text-sm font-medium space-x-2 ">
                                    <div v-html="item.svg"></div>
                                    <p :class="{ 'lg:hidden': !getshowSideNav }" >{{ item.name }}</p>
                                </router-link>
                                <span :class="{ 'lg:hidden': !getshowSideNav }"  class="mr-2 shrink-0 transition duration-300 group-open:-rotate-180">
                                    <svg v-if="item.sublinks.length" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" /></svg>
                                </span>
                            </summary>
                            <ul v-if="item.sublinks.length"  class="mt-2 space-y-1 px-2">
                                <li v-for="sublink in item.sublinks" :key="sublink.id">
                                    <a :href="sublink.url" class="block rounded-lg pl-8 py-2 text-sm text-left font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-700">
                                        {{ sublink.name }}
                                    </a>
                                </li>
                            </ul>
                        </details>
                    </li>
                </ul>
            </div>
            </div>
        </div>

        <div class="sticky inset-x-0 bottom-0 border-t border-gray-100 bg-white p-2">
            <button @click="LOG_USER_OUT()" type="button" class="group relative flex w-full justify-center rounded-lg border px-2 py-1.5 text-sm text-gray-500 hover:bg-gray-50 hover:text-gray-700">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 opacity-75" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>
                <span :class="{'lg:hidden': !getshowSideNav}" class="ml-3"> Sair </span>
            </button>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex';

    export default {
        name: "SideNavComponnent",
        components: {},
        data() {
            return {
            }
        },
        methods: {
            ...mapMutations(['SET_SHOW_SIDE_NAV', 'LOG_USER_OUT']),

            activeNavItem(item) {
                return this.$route.path === item.url;
            }
        },
        computed: {
            ...mapGetters(['getshowSideNav', 'getItensNavBar']),
        }
    }
</script>
<style scoped>
    button {
        background: transparent;
    }
</style>